import { GAMES_ORDER_TYPE_LABELS } from "entities/modules/constants";
import { GamesOrderType } from "entities/modules/types";
import { SelectOption } from "shared/components/Form/Select";

export const gamesOrderTypeOptions: SelectOption[] = [
  {
    value: GamesOrderType.Random,
    label: GAMES_ORDER_TYPE_LABELS[GamesOrderType.Random],
  },
  {
    value: GamesOrderType.Manual,
    label: GAMES_ORDER_TYPE_LABELS[GamesOrderType.Manual],
  },
];
